<template>
  <div class="cookAllowance">
    <div class="p16 align-items">
      <p style="font-weight: bold;">岗位补贴<span class="moneys fontSize14">（当天的数据将在次日0点更新，最终的补贴金额以店员补贴中的数据为准）</span></p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <el-tabs v-model="query.shopWorkType" class="plr16" @tab-click="handleClick">
            <el-tab-pane label="厨师补贴" name="cook"></el-tab-pane>
            <!-- <el-tab-pane label="收银补贴" name="cashier"></el-tab-pane> -->
            <el-tab-pane label="副店长补贴" name="viceShopManager"></el-tab-pane>
          </el-tabs>
          <div class="member-header space-between">
            <div>
              <el-date-picker v-model="query.dataMonth" type="month" value-format="yyyy-MM" placeholder="选择月"
                :clearable="false"></el-date-picker>
              <el-select v-model="query.staffId" placeholder="全部状态" filterable class="ml10">
                <el-option v-for="item in staffList" :key="item.id" :label="item.staffName" :value="item.id">
                </el-option>
              </el-select>
              <el-button type="primary ml10" @click="totalCounts">搜索</el-button>
            </div>
            <div>
              <el-button type="primary" @click="setCookAllowance" v-perm="{key:'cookAllowance', value: 'cookAllowance:config'}">设置{{ setTitle }}</el-button>
              <el-button type="primary" @click="addSubsidies" v-if="list.updateFlag" v-perm="{key:'cookAllowance', value: 'cookAllowance:update'}">修改</el-button>
            </div>
          </div>
          <el-tabs v-model="activeName" type="card" class="plr16">
            <el-tab-pane label="补贴明细" name="first"></el-tab-pane>
            <el-tab-pane label="补贴标准" name="second"></el-tab-pane>
          </el-tabs>
          <div class="plr16" v-if="activeName == 'first'" v-perm="{key:'cookAllowance', value: 'cookAllowance:detail'}">
            <el-table :data="list.shopWorkDayList" :max-height="height - 295"
              header-cell-class-name="table_header_bgcolor" :summary-method="getSummaries" show-summary>
              <el-table-column :prop="index" :align="item.align" :label="item.label" :width="item.width"
                :min-width="item.minWidth" :show-overflow-tooltip="false" v-for="(item, index) in columns" :key="index">
                <template slot-scope="scope">
                  <div v-if="index == 'openFlag'">
                    {{ scope.row.openFlag == 'yes' ? scope.row.guaranteeFlagCn : '' }}
                  </div>
                  <div v-else>{{ Boolean(item.formatDay) ? formatDay(scope.row[index]) : scope.row[index] }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="plr16" v-if="activeName == 'second'" v-perm="{key:'cookAllowance', value: 'cookAllowance:detail'}">
            <el-table :data="list.subsidySetDetailBoList" :max-height="height - 265" :span-method="objectSpanMethod"
              header-cell-class-name="table_header_bgcolor" v-if="query.shopWorkType == 'cook'" :key="'first'">
              <el-table-column prop="subsidyTypeCn" label="补贴类型">
                <template slot-scope="scope">{{ scope.row.guaranteeFlag == 'yes' ? '入职补助技师' : '非入职补助技师' }} </template>
              </el-table-column>
              <el-table-column prop="workStaffNum" label="在店人数" width="auto"></el-table-column>
              <el-table-column prop="amount" label="补贴金额/月" width="auto"></el-table-column>
            </el-table>
            <el-table :data="list.subsidySetDetailBoList" :max-height="height - 265" :span-method="objectSpanMethod"
              header-cell-class-name="table_header_bgcolor" v-if="query.shopWorkType != 'cook'" :key="'second'">
              <el-table-column prop="amount" label="补贴金额/月" width="auto"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="'设置' + setTitle" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px" label-position="left">
        <el-form-item ref="workTypeFlag" :label="'配备' + setTitle" prop="workTypeFlag" class="flex-rows">
          <el-switch v-model="form.workTypeFlag" active-value="yes" inactive-value="no">
          </el-switch>
        </el-form-item>
        <el-form-item label="备注" class="flex-rows" v-if="form.workTypeFlag == 'no'">
          店员离职（调店），系统自动关闭配备{{ setTitle }}
        </el-form-item>
        <el-form-item ref="beginTime" label="开始时间" prop="beginTime" v-if="form.workTypeFlag == 'yes'">
          <div>{{ formatDay(new Date()) }}</div>
        </el-form-item>
        <template v-if="form.workTypeFlag == 'yes'">
          <el-form-item ref="staffId" label="选择店员" prop="staffId" class="flex-rows">
            <el-select v-model="allStaffId" placeholder="请选择" filterable @change="onStaffList" class="w200">
              <el-option v-for="item in chefStaffList" :key="item.id" :label="item.staffName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <div>
          提示：从选择的日期开始，门店的厨师/副店长人员自动沿用前一天的配置，如果人员未发生变更，无需修改此配置。
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
    <edit-vue ref="editVue" @change="editBack"></edit-vue>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import editVue from "./edit.vue";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [],
      height: this.$store.getters.MainHeight,
      columns: config.columns,
      staffList: [], // 全部店员
      chefStaffList: [], // 没有全部店员选项
      query: {
        staffId: '',
        dataMonth: '',
        shopWorkType: 'cook'
      },
      form: {
        shopWorkType: 'cook',
        beginTime: '',
        endTime: '',
        workTypeFlag: '',
        staffId: '',
        satffName: ''
      },
      parmar: {
        beginTime: '',
        endTime: '',
        openFlag: 'no',
        staffId: '',
        satffName: '',
        shopWorkType: 'cook'
      },
      activeName: 'first',
      dialogVisible: false,
      setTitle: '厨师',
      allStaffId: '',
      totalAmount: '' // 汇总金额
    };
  },
  components: {editVue},
  computed: {
    beginPickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      }
    }
  },
  created() {
    this.query.dataMonth = this.formatMonth(new Date())
    this.totalCounts();
    this.companyStaffList();
  },
  mounted() {
    // console.log(config);
  },
  methods: {
    handleClick(tab, event) {
      if (this.query.shopWorkType == 'cook') {
        this.columns = config.columns;
        this.setTitle = "厨师";
        console.log('厨师', this.columns);
      } else if (this.query.shopWorkType == 'cashier') {
        this.setTitle = "收银员";
        this.columns = config.otherColumns;
      } else {
        this.setTitle = "副店长";
        this.columns = config.otherColumns;
        console.log('副店长', this.columns);
      }
      this.totalCounts();
    },
    addSubsidies() {
      this.$refs.editVue.init({ updateMonth: this.query.dataMonth, shopWorkType: this.query.shopWorkType})
    },
    handleClose() {
      this.form = {
        shopWorkType: 'cook',
        beginTime: '',
        endTime: '',
        workTypeFlag: '',
        staffId: '',
        satffName: ''
      }
      this.parmar = {
        beginTime: '',
        endTime: '',
        openFlag: 'no',
        staffId: '',
        satffName: '',
        shopWorkType: 'cook'
      }
      this.allStaffId = "";
      this.dialogVisible = false;
    },
    onDate(type) {
      console.log(this.formatMonth(new Date()), this.formatMonth(this.parmar.beginTime));
      // if (type == 'start' && this.formatMonth(new Date()) != this.formatMonth(this.parmar.beginTime)) {
      //   this.parmar.beginTime = "";
      //   return this.$message.error("请选择当前月份的日期");
      // } else if (type == 'end' && this.formatMonth(new Date()) != this.formatMonth(this.parmar.endTime)) {
      //   this.parmar.endTime = "";
      //   return this.$message.error("请选择当前月份的日期");
      // }
      if (this.parmar.beginTime && this.parmar.endTime && new Date(this.parmar.beginTime).getTime() > new Date(this.parmar.endTime).getTime()) {
        this.parmar.endTime = "";
        return this.$message.error("结束时间不能小于开始时间");
      }
    },
    setCookAllowance() {
      this.form.shopWorkType = this.query.shopWorkType;
      // 判断当前是什么类型    厨师，收银，副店长  请求对应的接口
      this.getWorkConfig();
    },
    getWorkConfig() { // 获取厨师是否设置
      this.$api.get(this.$url.shopWorkConfig.get, { shopWorkType: this.query.shopWorkType }).then(res => {
        if (res) {
          this.form = res;
          this.allStaffId = res.staffId;
          this.createdWorkTypeFlag = JSON.parse(JSON.stringify(res.workTypeFlag));
        } else {
          this.createdWorkTypeFlag = 'no';
        }
      })
      this.dialogVisible = true;
    },
    companyStaffList() {
      this.$api.post(this.$url.companyStaff.listAuthForData).then(res => {
        if (res) {
          this.staffList = res;
          res.map((item, index) => {
            if (index != 0) {
              this.chefStaffList.push(item);
            }
          })
          // this.updateStaffList = JSON.parse(JSON.stringify(this.chefStaffList));
        }
      }).catch(error => { });
    },
    onStaffList() {
      this.chefStaffList.map(item => {
        if (item.id == this.allStaffId) {
          this.form.staffId = item.id;
          this.form.staffName = item.staffName;
        }
      })
    },
    totalCounts() {
      this.$api.post(this.$url.shopWork.details, this.query).then(res => {
        if (res) {
          this.list = res;
          this.totalAmount = res.totalAmount
          console.log(this.totalAmount);
        }
      }).catch(error => { });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 1,
            colspan: 1
          };
        } else if (rowIndex === 1) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    save() {
      // if (this.createdWorkTypeFlag == this.form.workTypeFlag && this.createdWorkTypeFlag == "no") {
      //   return this.$message.error(this.setTitle + "已是关闭状态");
      // } else if (this.createdWorkTypeFlag == this.form.workTypeFlag && this.createdWorkTypeFlag == "yes") {
      //   return this.$message.error(this.setTitle + "已是开启状态");
      // }
      if (!this.form.staffId && this.form.workTypeFlag == "yes") {
        return this.$message.error("请选择店员");
      }
      this.$api.post(this.$url.shopWorkConfig.save, this.form).then(res => {
        if (res) {
          this.allStaffId = "";
          this.form = {
            shopWorkType: this.query.shopWorkType,
            beginTime: '',
            endTime: '',
            openFlag: 'no',
            satffId: '',
            satffName: ''
          }
          this.$message.success("操作成功");
          this.dialogVisible = false;
        }
      })
    },
    // 设置汇总行
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.query.shopWorkType == 'cook') {
        columns.forEach((column, index) => {
          sums[0] = '汇总金额：';
          sums[5] = this.totalAmount + '元';
        });
        return sums;
      } else {
        columns.forEach((column, index) => {
          sums[0] = '汇总金额：';
          sums[4] = this.totalAmount + '元';
        });
        return sums;
      }
    },
    editBack (org) {
      if (org) this.totalCounts();
    },
    // addClick(item) {
    //   console.log(item)
    //   this.$refs["addBorrowInfoForm"].$emit("set");
    // },
    // addBorrowInfo(bool) {
    //   if (bool) {
    //     this.totalCounts();
    //   }
    // },
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";

.cookAllowance {
  height: 100%;

  .mains-content {
    height: calc(100vh - 127px);
    // display: flex;
    background: #fff;

    // align-items: center;
    // justify-content: center;
    .member-header {
      padding: 0 16px 16px;
    }

    border-radius: 10px;

    .comingSoon-img {
      width: 170px;
      height: 170px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .comingSoon-title {
      text-align: center;
      margin-top: 20px;
      color: #A7A7A7;
      font-size: 16px;
    }
  }
}
</style>